import { ICheckboxGroup } from '@into-discovery/browsewebshared';
import { IOption } from '@into-discovery/browsewebshared';
import { useEffect, useState } from 'react';

const sortUniversityOptions = (options: IOption[]) => {
  options.sort((a, b) => {
    if (a.text < b.text) {
      return -1;
    }
    if (a.text > b.text) {
      return 1;
    }
    return 0;
  });
  return options;
};

function orderFacets(
  facets: ICheckboxGroup[],
  isUniversitiesFacetsFullList: boolean,
): ICheckboxGroup[] {
  // deep copy
  const result = facets.map((f) => ({ ...f }));
  const universityFacet = result.find(
    (f) => f.name === process.env.NEXT_PUBLIC_UNIVERSITY_FACET_NAME,
  );
  if (universityFacet) {
    universityFacet.options = sortUniversityOptions(universityFacet.options);
    const index = result.indexOf(universityFacet);
    result.splice(index, 1);
    result.push(universityFacet);
  }

  const universitiesIndex = result.findIndex(
    (f) => f.name === process.env.NEXT_PUBLIC_UNIVERSITY_FACET_NAME,
  );

  if (!isUniversitiesFacetsFullList && universitiesIndex >= 0) {
    result[universitiesIndex].options = result[universitiesIndex].options.slice(0, 10);
  }
  return result;
}

export const useFacets = (facets: ICheckboxGroup[], isUniversitiesFacetsFullList: boolean) => {
  const state = useState<ICheckboxGroup[]>([]);
  const [, setStateData] = state;

  useEffect(() => {
    setStateData(orderFacets(facets, isUniversitiesFacetsFullList));
  }, [setStateData, facets, isUniversitiesFacetsFullList]);

  return state;
};
